import BaseComponent from '../base/baseComponent';
export default class QuantityAddToCart extends BaseComponent {
    get SELECTORS() {
        return {
            incrementBtn: '.js-add-quantity',
            decrementBtn: '.js-remove-quantity',
            inputQuantity: '.js-input-quantity'
        };
    }
    get CLASSES() {
        return {
            hidden: 'd-none',
            disabled: 'disabled'
        };
    }
    constructor(element) {
        super(element);
        this.incrementQuantity();
        this.decrementQuantity();
    }
    incrementQuantity() {
        const incrementBtn = this._el.querySelector(this.SELECTORS.incrementBtn);
        const decrementBtn = this._el.querySelector(this.SELECTORS.decrementBtn);
        incrementBtn.addEventListener('click', (e) => {
            let inputQuantity = this._el.querySelector(this.SELECTORS.inputQuantity);
            if (inputQuantity) {
                let minQty = parseInt(inputQuantity.dataset.minqty, 10);
                let maxQty = parseInt(inputQuantity.dataset.maxqty, 10);
                let currentQuantity = parseInt(inputQuantity.value, 10);
                let newQuantity = currentQuantity + 1;
                inputQuantity.value = String(newQuantity);
                inputQuantity.setAttribute('aria-label', String(newQuantity));
                if (newQuantity >= maxQty) {
                    incrementBtn.classList.add(this.CLASSES.disabled);
                    incrementBtn.setAttribute('disabled', 'true');
                }
                else {
                    incrementBtn.classList.remove(this.CLASSES.disabled);
                    incrementBtn.removeAttribute('disabled');
                }
                if (newQuantity > minQty) {
                    decrementBtn.classList.remove(this.CLASSES.disabled);
                    decrementBtn.removeAttribute('disabled');
                }
                else {
                    decrementBtn.classList.add(this.CLASSES.disabled);
                    decrementBtn.setAttribute('disabled', 'true');
                }
            }
        });
    }
    decrementQuantity() {
        const decrementBtn = this._el.querySelector(this.SELECTORS.decrementBtn);
        const incrementBtn = this._el.querySelector(this.SELECTORS.incrementBtn);
        decrementBtn.addEventListener('click', (e) => {
            let inputQuantity = this._el.querySelector(this.SELECTORS.inputQuantity);
            if (inputQuantity) {
                let minQty = parseInt(inputQuantity.dataset.minqty, 10);
                let maxQty = parseInt(inputQuantity.dataset.maxqty, 10);
                let currentQuantity = parseInt(inputQuantity.value, 10);
                let newQuantity = currentQuantity - 1;
                inputQuantity.value = String(newQuantity);
                inputQuantity.setAttribute('aria-label', String(newQuantity));
                if (newQuantity <= minQty) {
                    decrementBtn.classList.add(this.CLASSES.disabled);
                    decrementBtn.setAttribute('disabled', 'true');
                }
                else {
                    decrementBtn.classList.remove(this.CLASSES.disabled);
                    decrementBtn.removeAttribute('disabled');
                }
                if (newQuantity < maxQty) {
                    incrementBtn.classList.remove(this.CLASSES.disabled);
                    incrementBtn.removeAttribute('disabled');
                }
                else {
                    incrementBtn.classList.add(this.CLASSES.disabled);
                    incrementBtn.setAttribute('disabled', 'true');
                }
            }
        });
    }
}
